var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import colors from '../../colors';
import MuiBox from '@mui/material/Box';
import { Tab } from './Tab';
import Typography from '../Typography';
import { ChevronDown, ChevronUp } from '../../icons';
import { Popover } from '@mui/material';
import MuiMenuItem from '@mui/material/MenuItem';
import { LabelWithBadge } from './LabelWithBadge';
export var DropdownTab = function (_a) {
    var dropdown = _a.dropdown, value = _a.value, handleChange = _a.handleChange;
    var isDropdownItemActive = !!value && !!(dropdown === null || dropdown === void 0 ? void 0 : dropdown.tabs.map(function (item) { return item.value; }).includes(value));
    var _b = useState(null), dropdownAnchorEl = _b[0], setDropdownAnchorEl = _b[1];
    var color = isDropdownItemActive || Boolean(dropdownAnchorEl) ? colors.blue[500] : colors.grey[800];
    return (_jsxs(MuiBox, __assign({ display: "flex", alignItems: "center" }, { children: [_jsx(Tab, { isActive: isDropdownItemActive, label: _jsxs(MuiBox, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 1, height: '30px' } }, { children: [_jsx(Typography, __assign({ color: color, variant: 'body' }, { children: dropdown.title })), Boolean(dropdownAnchorEl) ? (_jsx(ChevronUp, { color: color })) : (_jsx(ChevronDown, { color: color }))] })), onClick: function (event) {
                    event.stopPropagation();
                    setDropdownAnchorEl(event.currentTarget);
                } }), _jsx(Popover, __assign({ onClose: function () { return setDropdownAnchorEl(null); }, anchorEl: dropdownAnchorEl, open: Boolean(dropdownAnchorEl), PaperProps: {
                    sx: {
                        boxShadow: '0px 2px 12px 0px color(display-p3 0 0 0 / 0.10)',
                        borderRadius: 1,
                        width: '250px',
                        mt: 1,
                    },
                }, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                }, transformOrigin: { horizontal: 'left', vertical: 'top' } }, { children: _jsx(MuiBox, __assign({ sx: {
                        p: 1,
                        '& .MuiButtonBase-root > div': { justifyContent: 'space-between', width: '100%' },
                    } }, { children: dropdown.tabs.map(function (tabListItem, idx) {
                        var _a;
                        return (_jsx(MuiMenuItem, __assign({ value: value, onClick: function (event) {
                                event.stopPropagation();
                                handleChange(event, tabListItem.value);
                                setDropdownAnchorEl(null);
                            }, sx: { p: '8px 12px', borderRadius: 1, height: '40px' } }, { children: _jsx(LabelWithBadge, { label: tabListItem.label, badgeLabel: (_a = tabListItem.badgeLabel) !== null && _a !== void 0 ? _a : '0', isActive: tabListItem.value === value }) }), "tab_list_".concat(tabListItem.label).concat(idx)));
                    }) })) }))] })));
};
